import env from "../../env.json";
import axios from "axios";
import { getToken,getDeviceToken} from "../../common.js";
import { getCurrentLocale } from "../../locale/language";

const baseUrl = env.baseUrl;
const driverListBase = env.driverListBaseUrl || baseUrl.replace(/superadmin\/?$/, "newdriver/admin/");
const justbuyBase = baseUrl.replace(/superadmin\/?$/, "justbuy/");
const baseUrllogin = env.baseUrllogin || baseUrl.replace(/superadmin\/?$/, "login/");
const helpersBase = env.helpersBaseUrl || baseUrl.replace(/superadmin\/?$/, "helpers/");
const baseUrluser = env.baseUrluser || baseUrl.replace(/superadmin\/?$/, "user/");
const baseUrlmain = env.baseUrlmain || baseUrl.replace(/superadmin\/?$/, "newdriver/");
const decode = (txt) => {
  let result = atob(txt);
  return result;
};
// const token =  decode(getToken());

const lang=getCurrentLocale()

export const createDriver = async (datas) => {
  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "registerdriver/",
      data: datas,
      headers: {
        "content-type": "application/json",
        "language":lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const createDriverByAdmin = async (payload) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "POST",
      url: baseUrlmain + "newdriver/create/driver/",
      data: payload,
      headers: {
        Authorization: "token " + token,
        "Content-Type": "application/json",
        "device-name": "web",
        "language": lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const validateDriverEmail = async (email) => {
  try {
    let data = await axios({
      method: "POST",
      url: baseUrlmain + "newdriver/validate/email/",
      data: { email },
      headers: {
        "Content-Type": "application/json",
        "device-name": "web",
        "language": lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const validateDriverPhone = async (phone_number) => {
  try {
    let data = await axios({
      method: "POST",
      url: baseUrlmain + "newdriver/validate/email/",
      data: { phone_number },
      headers: {
        "Content-Type": "application/json",
        "device-name": "web",
        "language": lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const userProfile = async () => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrllogin + "me/" ,//baseUrl
      headers: { Authorization: "token " + token ,"language":lang},
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const phoneVerify = async (number) => {
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "phoneverify/?phone="+number ,
      headers: {"language":lang},
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const createAdmin = async (datas) => {
  let token = decode(getToken());

  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "registeradmin/",
      data: datas,
      headers: {
        "content-type": "application/json",
       "Authorization": "token " + token ,
       "language":lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const createSuperUser = async ({ full_name, email, phone_number }) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "POST",
      url: baseUrluser + "create-superuser/",
      data: { full_name, email, phone_number },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + token,
        "device-name": "web",
        language: lang,
        Accept: "application/json, text/plain, */*"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getSuperUsers = async (page = 1) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrluser + "create-superuser/?page=" + page,
      headers: {
        Authorization: "token " + token,
        "Content-Type": "application/json",
        "device-name": "web",
        language: lang,
        Accept: "application/json, text/plain, */*"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const createManager = async (datas) => {
  let token = decode(getToken());

  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "registermanager/",
      data: datas,
      headers: {
        "content-type": "application/json",
       "Authorization": "token " + token ,
       "language":lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const uploadDocuments = async (datas) => {
  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "driveruploaddocuments/",
      data: datas,
      headers: {
        "content-type": "multipart/form-data",
        "language":lang
      },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getDriverList = async (query_for, page = 1, query = "") => {
  let token = decode(getToken());
  try {
    let url = driverListBase + "driver-list/?query_for=" + encodeURIComponent(query_for) + "&page=" + page;
    if (query) url += "&query=" + encodeURIComponent(query);
    let data = await axios({
      method: "GET",
      url,
      headers: { Authorization: "token " + token, "Content-Type": "application/json", "device-name": "web", "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getDrivers = async (is_promoted,pageno,status,is_deactivated="",query="") => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "getdrivers/?is_promoted=" + is_promoted+"&status="+status+"&is_deactivated="+is_deactivated+"&page="+pageno+"&query="+query,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getDriverssearch = async (is_promoted,status,is_deactivated="",query="") => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "getdrivers/?is_promoted=" + is_promoted+"&status="+status+"&is_deactivated="+is_deactivated+"&query="+query,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const editDriver = async (driverData,id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "editdriver/?driver_id=" + id,
      data:driverData,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const searchdriver = async (input,is_promoted,status) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "searchdriver/?query=" + input + "&&is_promoted=" + is_promoted+"&status="+status ,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getPromotedDrivers = async (pageno) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "getdrivers/?is_promoted=true&page="+pageno,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const searchpromoteddriver = async (input) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "searchdriver/?query=" + input + "&&is_promoted=true",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

function normalizeDriverDetailResponse(response) {
  const rd = response?.data?.ResponseData;
  const driver = rd?.data || rd;
  if (!driver) return response;
  if (driver.file_data) return response;
  const dl = Array.isArray(driver.driver_licsence) ? driver.driver_licsence : [];
  const dlUrls = dl.map((f) => (typeof f === "string" ? f : f?.file ?? f?.url ?? ""));
  const dlNames = dl.map((f) => (typeof f === "string" ? f : f?.file ?? f?.name ?? f?.url ?? ""));
  const nric = Array.isArray(driver.nric_work_permit) ? driver.nric_work_permit : [];
  const nricUrls = nric.map((f) => (typeof f === "string" ? f : f?.file ?? f?.url ?? ""));
  const nricNames = nric.map((f) => (typeof f === "string" ? f : f?.file ?? f?.name ?? f?.url ?? ""));
  const pp = driver.passport_photo;
  const passportUrl = pp && typeof pp === "object" ? (pp.file ?? pp.url ?? null) : (pp || null);
  response.data.ResponseData = {
    ...driver,
    file_data: {
      driver_licsence: { url: dlUrls, names_of_files: dlNames, number_of_files: dl.length },
      nric_work_permit: { url: nricUrls, names_of_files: nricNames, number_of_files: nric.length },
      passport_photo: { url: passportUrl }
    }
  };
  return response;
}

export const getDriverDetails = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: driverListBase + "driver-detail/?driver_meta_id=" + id,//baseUrl + "driverdetail/?driver_id=" + id,
      headers: { Authorization: "token " + token, "Content-Type": "application/json", "device-name": "web", "language": lang }
    });
    return normalizeDriverDetailResponse(data);
  } catch (error) {
    return error.response;
  }
};

export const updateDriverStatus = async (driver_meta_id, status, rejection_reason) => {
  let token = decode(getToken());
  try {
    let body = { driver_meta_id, status };
    if (status === "rejected" && rejection_reason) body.rejected_reason = rejection_reason;
    let data = await axios({
      method: "PUT",
      url: driverListBase + "update-driver-status/",
      data: body,
      headers: { Authorization: "token " + token, "Content-Type": "application/json", "device-name": "web", "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getUserDriverCount = async () => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: driverListBase + "user-driver/count/",
      headers: { Authorization: "token " + token, "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getManagers = async (pageno) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: pageno===""?baseUrl + "filteradminmanager/?role=3":baseUrl + "filteradminmanager/?role=3&page="+pageno,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getAdmins = async (pageno) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "filteradminmanager/?role=2&page="+pageno,
      headers: { Authorization: "token " + token ,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const searchAdmin = async (input,role) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "filteradminmanager/?query=" + input + "&role="+role,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getAdminProfile = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "detail/?admin_id="+id,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getManagerProfile = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "managerdetail/?manager_id="+id,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const checkDriverDocument = async (id) => {
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "checkdriverdocumentsurl/?driver_id="+id,
      headers: {"language":lang },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const assignManager = async (driverId, managerId) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "assignmanager/?driver_id=" + driverId + "&manager_id=" + managerId,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const ManagerUpdate = async (managerid,managerData) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "managerupdate/?manager_id=" + managerid ,
      data:managerData,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const AdminUpdate = async (adminid,adminData) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "update/?superadmin_id=" + adminid ,
      data:adminData,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const promoteRequest = async (driverId) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "updatedriver/?driver_id=" + driverId + "&operation=promote",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};
  

export const deleteRequest = async (driverId) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "updatedriver/?driver_id=" + driverId + "&operation=delete",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const approveDriver = async (datas) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "driverupdatestatus/",
      headers: { Authorization: "token " + token ,
      "language":lang
    },
      data : datas
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const OnHoldRequest = async (driverId,operation) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "updatedriver/?driver_id=" + driverId + "&operation=" + operation,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const deleteFile = async (fileName) => {
  let token = decode(getToken());
  let body={
    "file_names":fileName
  }
  try {
    let data = await axios({
      method: "DELETE",
      url: baseUrl + "deletefile/",
      headers: { Authorization: "token " + token,
      "language":lang},
      data:body
    });
    return data;
  } catch (error) {
    return error.response;
  }
};
export const login = async (userData) => {
  try {
    let data = await axios({
      method: "POST",
      url: baseUrllogin + "login/",
      headers: {"language":lang,'device-name':'ubuntu' },
      data: userData,
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const forgot = async (userData) => {
  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "forgotpassword/",
      headers: {"language":lang },
      data: userData,
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const resetpassword = async (userData) => {
  try {
    let data = await axios({
      method: "PUT",
      url: baseUrl + "resetpassword/",
      headers: {"language":"en" },
      data: userData,
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const logout = async () => {
  try{
    let data = await axios({
      method: "POST",
      url: baseUrl + "logout/",
    });
    return data;
  } catch (error){
    return error.response
  }
}

export const getOrders = async (type,pageno) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "orders/?order_type="+ type+"&page="+pageno,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getOrderDetails = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "orders/"+ id+"/",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const searchOrder = async (input,role) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "orders/?order_type="+ role + "&driver_full_name="+input,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getUserOrderHistory = async (page = "") => {
  let token = decode(getToken());
  try {
    let url = baseUrluser + "order-history/";
    if (page) url = baseUrluser + "order-history/?page=" + page;
    let data = await axios({
      method: "GET",
      url,
      headers: {
        Authorization: "token " + token,
        language: lang,
        "device-name": "web",
        Accept: "application/json, text/plain, */*"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const registerNotificationToken = async () => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "POST",
      url: baseUrl + "utils/",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    data:{
      "firebase": {
        "device_token":"token "+getDeviceToken(),
        "device_type": "wb"
      }
    }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const notificationList = async (pno) => 
{
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "notifications/?page="+pno,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const notificationListMain = async (pno) => 
{
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrluser + "admin-notifications/",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const notificationListMainPatch = async (id) => 
{
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PATCH",
      url: baseUrluser + "admin-notifications/",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    data:{
      "ids":[id]
    }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const ReadandDeleteNotification = async (operation,id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "notification/"+operation+"/?multiple_notifications="+id,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getUserList = async (page = "") => {
  let token = decode(getToken());
  try {
    let url = baseUrluser + "user-list/";
    if (page) url = baseUrluser + "user-list/?page=" + page;
    let data = await axios({
      method: "GET",
      url,
      headers: {
        Authorization: "token " + token,
        language: lang,
        "device-name": "web",
        Accept: "application/json, text/plain, */*"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getPayments = async (type,pageno) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "transactions/?service="+type+"&page="+pageno,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const searchPayments = async (input,role) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "transactions/?service="+role+"&query=" + input,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getPaypalPayments = async (page = 1) => {
  let token = decode(getToken());
  try {
    let url = baseUrluser + "paypal-payments/";
    if (page) url = baseUrluser + "paypal-payments/?page=" + page;
    let data = await axios({
      method: "GET",
      url,
      headers: { Authorization: "token " + token, language: lang, "device-name": "web", Accept: "application/json, text/plain, */*"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getProducts = async (type,pageno) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrllogin + "products/?page="+pageno,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const searchProducts = async (input,role) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "products/?query=" + input,
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getProductDetails = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl +"products/"+id+"/",
      headers: { Authorization: "token " + token,
      "language":lang
    },
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

function toCampaignPayload(body) {
  return {
    name: body.name,
    banner_image: Number(body.banner_image) || body.banner_image,
    banner_redirect_url: body.banner_redirect_url || "",
    is_active: body.is_active !== false,
    description: body.description || "",
    start_date: body.start_date,
    end_date: body.end_date,
    banner_type: body.banner_type,
    weekday: body.weekday || [],
    category: body.category || [],
    product: body.product || [],
    merchant: Array.isArray(body.merchant) ? body.merchant : (body.merchant ? [String(body.merchant)] : []),
    country: body.country || ""
  };
}

export const getCampaigns = async (page = 1) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: driverListBase + "banner/?page=" + page,
      headers: {
        Authorization: "token " + token,
        "language": lang,
        "Accept": "application/json, text/plain, */*",
        "device-name": "web"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getCampaignDetail = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: driverListBase + "get-update-banner/" + id + "/",
      headers: {
        Authorization: "token " + token,
        "language": lang,
        "Accept": "application/json, text/plain, */*",
        "device-name": "web"
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const createCampaign = async (body) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "POST",
      url: driverListBase + "banner/",
      data: toCampaignPayload(body),
      headers: { Authorization: "token " + token, "Content-Type": "application/json", "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const updateCampaign = async (id, body) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: driverListBase + "get-update-banner/" + id + "/",
      data: toCampaignPayload(body),
      headers: { Authorization: "token " + token, "Content-Type": "application/json", "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const updateCampaignStatus = async (id, is_active) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "PUT",
      url: driverListBase + "get-update-banner/" + id + "/",
      data: { is_active },
      headers: { Authorization: "token " + token, "Content-Type": "application/json", "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const deleteCampaign = async (id) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "DELETE",
      url: driverListBase + "get-update-banner/" + id + "/",
      headers: { Authorization: "token " + token, "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const uploadCampaignFile = async (formData) => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "POST",
      url: helpersBase + "fileupload/",
      data: formData,
      headers: {
        "language": lang
      }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getCampaignCountries = async () => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: baseUrl + "countries/",
      headers: { Authorization: "token " + token, "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getCampaignStates = async (countryName, stateId) => {
  let token = decode(getToken());
  try {
    let url = baseUrl + "countries/states/?country_name=" + encodeURIComponent(countryName || "");
    if (stateId) url += "&state_id=" + stateId;
    let data = await axios({
      method: "GET",
      url,
      headers: { Authorization: "token " + token, "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getCampaignMerchants = async () => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: driverListBase + "merchant/list/",
      headers: { Authorization: "token " + token, "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};

export const getCampaignCategories = async () => {
  let token = decode(getToken());
  try {
    let data = await axios({
      method: "GET",
      url: justbuyBase + "category/",
      headers: { Authorization: "token " + token, "language": lang }
    });
    return data;
  } catch (error) {
    return error.response;
  }
};